import { isPlatformBrowser } from '@angular/common';
import { Component, ElementRef, HostListener, Inject, PLATFORM_ID, Renderer2, RendererStyleFlags2 } from '@angular/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {

  notSticky: boolean = false;
  isMenuActive: boolean = false;
  isBackdropActive: boolean = false;
  
  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private el: ElementRef,
    private renderer: Renderer2
  ) {}

   ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      const dropdownToggle = this.el.nativeElement.querySelectorAll('.dropdown-toggle');
      const dropdownMenus = this.el.nativeElement.querySelectorAll('.dropdown-menu');
      const menuCardLinks = this.el.nativeElement.querySelectorAll('.menu-card a');

      dropdownToggle.forEach((toggle: HTMLElement) => {
        this.renderer.listen(toggle, 'mouseover', () => {
          const dropdownMenu = toggle.nextElementSibling as HTMLElement;
          if (dropdownMenu) {
            this.renderer.setStyle(dropdownMenu, 'opacity', '1');
            this.renderer.setStyle(dropdownMenu, 'visibility', 'visible');
          }
        });
      });

      menuCardLinks.forEach((link: HTMLElement) => {
        this.renderer.listen(link, 'click', () => {
          dropdownMenus.forEach((menu: HTMLElement) => {
            this.renderer.setStyle(menu, 'opacity', '0', RendererStyleFlags2.Important);
            this.renderer.setStyle(menu, 'visibility', 'hidden', RendererStyleFlags2.Important);
          });
        });
      });

      // Close dropdowns if clicking outside of them
      this.renderer.listen('document', 'click', (event: Event) => {
        if (!this.el.nativeElement.contains(event.target)) {
          dropdownMenus.forEach((menu: HTMLElement) => {
            this.renderer.setStyle(menu, 'opacity', '0', RendererStyleFlags2.Important);
            this.renderer.setStyle(menu, 'visibility', 'hidden', RendererStyleFlags2.Important);
          });
        }
      });
    }
  }

  closeCanvasMenu() {
    this.isBackdropActive = false;
    const offCanvasMenu = document.querySelector('.navbar-collapse.offcanvas');
    if (offCanvasMenu) {
      offCanvasMenu.classList.add('hiding');
      setTimeout(() => {
        this.isMenuActive = false;
        offCanvasMenu.classList.remove('hiding', 'show');
      }, 300);
    }
  }
  
  toggleOffCanvasMenu() {
    const offCanvasMenu = document.querySelector('.navbar-collapse.offcanvas');
    this.isBackdropActive = true;
    if (!this.isMenuActive) {
      offCanvasMenu?.classList.add('showing');
      setTimeout(() => {
        this.isMenuActive = true;
        offCanvasMenu?.classList.remove('showing');
        offCanvasMenu?.classList.add('show');
      }, 300);
    } else {
      this.closeCanvasMenu();
    }
  }

  toggleClass(event: Event): void {
    const allPTags = document.querySelectorAll('.nav-link.dropdown-toggle');
    
    // Remove 'show' class from all <p> tags
    allPTags.forEach((pTag) => {
      pTag.classList.remove('show');
    });
  
    // Add 'show' class to the clicked <p> tag
    const clickedPTag = event.target as HTMLElement;
    clickedPTag.classList.toggle('show');
  }

  @HostListener('window:scroll', ['$event'])
  checkScroll() {
    this.notSticky = window.pageYOffset >= 100;
  }

 
}
